import React, { Component } from "react";
import { Collapse, Button, CardBody, Card,Badge, Alert  } from "reactstrap";
import { connect } from 'react-redux';
import { bake_cookie, userCookie, read_cookie,versionCookie } from '../../helpers/cookieHelper';

export default class HistoryLog extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: true,
      showLog:[],
      historyLog:[],
    };
  }

  componentDidMount(){
    this.cookieHandler(this.state.showLog.version_no)
  }

  setShowLog = (index) => {
    let showLog

    this.props.historyLog.forEach((obj) => {
      if(obj.version_no === index){
        showLog = obj
      }
    })

    this.setState({
      showLog:showLog
    });
  };

  toggle = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  cookieHandler =(latestVerNO)=>{
    const version = read_cookie(versionCookie)
    let verlist = version.verlist
    let haveSeen = false

    verlist.forEach(item=>{
      if(item === latestVerNO){
        haveSeen = true
      }
    })

    if(!haveSeen || verlist.length === 0){
      verlist.push(latestVerNO)
      bake_cookie(versionCookie,{verlist})
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.historyLog !== prevState.historyLog){
      // init set showLog
      const showLog =nextProps.historyLog[0]
      return {
        ...prevState,
        historyLog:nextProps.historyLog,
        showLog:showLog,
      }
    }else{
      return null
    }
  }
  


  render() {
    return (
      <div className="popup-modal conceptmap-edit-modal">
        <div className="popup-modal-header flex-between">
          <h3>歷史更版紀錄</h3>
          <i className="fa fa-close lowi-icon" onClick={() => this.props.toggle()}></i>
        </div>
        <div className="popup-modal-content">
          <div className="vBtn-group">
          {this.props.historyLog.map((item) => {
            return (
                  <Button   
                    key={item.version_no} 
                    onClick={() => {
                      this.setShowLog(item.version_no);
                    }}
                    size="sm"
                    color="primary"
                    style={{"fontSize": "0.8rem"}}
                  >
                   ver - {item.version_no}
                  </Button>
            );
          })}
          </div>

          <Collapse isOpen={this.state.isOpen}>
            <Card>
              <CardBody>
                <div className='version-content'>
                  <div className="version-title">
                    LOWI {this.state.showLog.version_no}
                    <div className="timespan">更新時間 : {this.state.showLog.updated_time}</div>
                  </div>
                  
                  <div className='textarea' dangerouslySetInnerHTML={{__html: this.state.showLog.items }}></div>
                </div>
              </CardBody>
            </Card>
            <Alert color="warning"> 點擊空白處或是上方的 "X" 按鈕關閉視窗 </Alert>
          </Collapse>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/popup/HistoryLog.js